export const NoAccess = () => {
    return <div className='flex flex-col space-y-3 p-10 pt-10'>
      <label>
        <span className="block text-xs font-medium text-slate-gray pb-1">
          If you would like access to this service, please contact us.
        </span>
      </label>
    </div>
  };